import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { CookieProductCaptureComponent } from './cookie-product-capture.component';

@NgModule({
  imports: [CommonModule, I18nModule, CookieProductCaptureComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CookieProductCaptureComponent: {
          component: CookieProductCaptureComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [CookieProductCaptureComponent],
})
export class CookieProductCaptureModule {}
